// extracted by mini-css-extract-plugin
export default {"root":"i1QSBOV","row":"Rv8DNux","vatCaption":"L9Lkr00"};